module.exports = __webpack_public_path__ + "img/BMWM11965300x300.5f54e9bb.jpg";